import { theme } from '@/utils/theme';

// MUI's default is 320; the extra width gives the day grid some air
export const CALENDAR_WIDTH = 360;

export const PANEL_INSET = 24;

export const EDGE_DAY_STYLES = {
  backgroundColor: `${theme.palette['orange-3'].main} !important`,
  color: theme.palette['white'].main,
  // Default is 36 with a 2px horizontal margin, edge days lose one margin
  width: '38px',
};
